import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type { CategoryDTO } from 'ecosystem/grand-connect'

export interface CategoryState {
  category: string | null
  categories: CategoryDTO[]
  menuCategories: CategoryDTO[]
  menuCategoryId: string | null
  menuCategory: CategoryDTO | null
}

const initialState: CategoryState = {
  category: null,
  categories: [],
  menuCategories: [],
  menuCategoryId: null,
  menuCategory: null
}

const slice = createSlice({
  name: 'category',
  initialState,
  reducers: {
    setSelectedCategories: (state, { payload: categories }: PayloadAction<CategoryDTO[]>) => {
      state.categories = categories
      return state
    },

    setSelectedMenuCategories: (state, { payload }: PayloadAction<CategoryDTO[]>) => {
      state.menuCategories = payload
      return state
    },

    setSelectedMenuCategoryId: (state, { payload }: PayloadAction<string | null>) => {
      state.menuCategoryId = payload
      return state
    },

    setSelectedMenuCategory: (
      state,
      { payload: menuCategory }: PayloadAction<CategoryState['menuCategory'] | null>
    ) => {
      state.menuCategory = menuCategory
    }
  }
})

// available actions - add more as needed, first they will have to be declared above
export const {
  setSelectedCategories,
  setSelectedMenuCategories,
  setSelectedMenuCategoryId,
  setSelectedMenuCategory
} = slice.actions

// exports slice reducer
export default slice.reducer
